import React, { lazy, Suspense } from 'react';

const LazySetting = lazy(() => import('./Setting'));

const Setting = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazySetting {...props} />
  </Suspense>
);

export default Setting;
